import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CreateNewArticlePublisherTaskForm from '../components/the-article-publisher/CreateNewArticlePublisherTaskForm.vue';
import ArticlePublisherTaskDataTable from '../components/the-article-publisher/ArticlePublisherTaskDataTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheArticlePublisher',
  setup(__props) {

const taskTableRef = ref<InstanceType<typeof ArticlePublisherTaskDataTable>>();

const onTaskCreated = () => {
  taskTableRef.value?.refresh();
};


return { __sfc: true,taskTableRef, onTaskCreated, CreateNewArticlePublisherTaskForm, ArticlePublisherTaskDataTable }
}

})